import { AnimatePresence, motion } from "motion/react";

import type { LenderApplicationsFilterEnum } from "@/features/common/enums";
import { useFilterStore } from "@/store/filters-menu/hooks/useFilterStore";

import { List } from "../components/requests/list/index";
import settings from "../settings";

const Dashboard = () => {
  const filters = useFilterStore((state) => state.filters);

  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={settings.routeAnimation.pageVariants}
      transition={settings.routeAnimation.pageTransition}
    >
      <AnimatePresence initial={true}>
        {filters.map((filter: LenderApplicationsFilterEnum, index: number) => (
          <List key={`${filter}-${index}`} filter={filter} />
        ))}
      </AnimatePresence>
    </motion.div>
  );
};

export default Dashboard;
